/* eslint-disable */

import axios from 'axios';
import { encryptStorage } from '../CustomStorage';
import { APP_CONSTANTS } from '../URLConstants';



const AudioCubeApiCallerInstance = axios.create({
  baseURL:
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? `${window?.location?.origin}/api/`
      : process.env.REACT_APP_SOUNDBOX_HOST_URL
  // withCredentials: true
});

AudioCubeApiCallerInstance.defaults.headers.common['Content-Type'] = 'application/json';
// AudioCubeApiCallerInstance.defaults.withCredentials = true;

AudioCubeApiCallerInstance.interceptors.request.use(
  (request) => {


    if (
      encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN) !== undefined &&
      encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN) !== null
    )
      request.headers['Authorization'] = `Bearer ${encryptStorage.getItem(
        APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN
      )}`;

    return request;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

AudioCubeApiCallerInstance.interceptors.response.use(
  (response) => {
    // if(process.env.REACT_APP_ENVIRONMENT === 'sandbox'){
    //     if(Array.isArray(response?.data?.data))
    //         return response;

    //     return response?.data
    // }

    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, null);
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, null);
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

export default AudioCubeApiCallerInstance;
